import Vue from 'vue'
import App from './App.vue'
import AppLayout from "@/layouts/AppLayout";

import router from "@/router";

Vue.component('AppLayout', AppLayout)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
